import styles from '@/components/models/travel/HeaderBlock/HeaderBlockInfoLabel/HeaderBlockInfoLabel.module.scss'

interface Props {
  label: string
}

const HeaderBlockInfoLabel = ({ label }: Props) => {
  return <div className={`${styles.root} btn btn-outline-secondary`} dangerouslySetInnerHTML={{ __html: label }} />
}

export default HeaderBlockInfoLabel
